import React from "react";
import * as agent from "../agent";
import { FormattedDate, FormattedNumber, FormattedTime } from "react-intl";
import InnerLink from "./InnerLink";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";

class CreditPayments extends React.Component {
    state = {
        transactionsLoaded: false,
        transactions: []
    }
    componentDidMount() {
        this.fetchData();
    }
    fetchData() {
        const { credit } = this.props;
        agent.Transactions.getByCredit(credit._id)
            .then(res => this.setState({
                transactions: res,
                transactionsLoaded: true
            }))
            .catch(err => alert(err.message));
    }
    render() {
        const { transactions = [], transactionsLoaded } = this.state;

        const thead = [
            "Дата",
            "Оплата",
            "Исполнитель",
            "Статья ДДС",
            "Контрагент",
            "Учетный счет",
            "Сумма",
            "Оплачено дней",
            "Комментарий"
        ];
        return transactionsLoaded ? (
            transactions.length > 0 ?
                <Table padding="checkbox">
                    <TableHead >
                        <TableRow >
                            {thead.map((th, i) => <TableCell key={i} >{th}</TableCell>)}
                        </TableRow>
                    </TableHead>
                    <TableBody >
                        {transactions.map(({
                            date,
                            paymentDate,
                            manager = {},
                            operation = {},
                            account,
                            contract,
                            counterparty,
                            period,
                            sum,
                            comment }, i) => {

                            const [managerLastname, managerFirstname = " ", managerThirdname = " " ] = (manager.fullname||"").split(" ");

                            return (
                                <TableRow key={i}>
                                    <TableCell>
                                        <FormattedDate value={date}
                                                       day="numeric"
                                                       month="numeric"
                                                       year="numeric" />
                                        <br />
                                        <FormattedTime value={date}
                                                       hour="numeric"
                                                       minute="numeric"
                                                       second="numeric" />
                                    </TableCell>
                                    <TableCell >
                                        <FormattedDate value={paymentDate}
                                                       day="numeric"
                                                       month="numeric"
                                                       year="numeric" />
                                        <br />
                                        <FormattedTime value={paymentDate}
                                                       hour="numeric"
                                                       minute="numeric"
                                                       second="numeric" />
                                    </TableCell>
                                    <TableCell>
                                        <InnerLink target="_blank"
                                                   href={`/user/${manager._id}`}
                                                   label={`${managerLastname} ${managerFirstname[0]}. ${managerThirdname[0]}.`} />
                                    </TableCell>
                                    <TableCell>
                                        { operation.name }
                                    </TableCell>
                                    <TableCell>
                                        { counterparty ? (counterparty||{}).name : "—" }
                                    </TableCell>
                                    <TableCell>
                                        { account.name }
                                    </TableCell>
                                    <TableCell>
                                        <FormattedNumber value={sum}
                                                         style={`currency`}
                                                         currency="RUB"
                                                         minimumFractionDigits={0} />
                                    </TableCell>
                                    <TableCell>
                                        { period ? (period||{}).duration : "" }
                                    </TableCell>
                                    <TableCell>
                                        {comment}
                                    </TableCell>
                                </TableRow>
                            )}
                        )}
                    </TableBody >
                </Table> : <Typography>Платежей нет</Typography>
            )
            :
            <React.Fragment>
                <Typography paragraph>Загрузка...</Typography>
                <CircularProgress />
            </React.Fragment>
    }
}

export default CreditPayments;



// WEBPACK FOOTER //
// ./src/components/CreditPayments.js